<template>
    <svg
        height="512"
        viewBox="0 0 512 512"
        width="512"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
    >
        <path d="m141 247a79.47 79.47 0 0 1 -39.6-10.53c-23.92 62.53-55.4 150.41-55.4 180.53a95 95 0 0 0 190 0c0-30.12-31.48-118-55.4-180.53a79.47 79.47 0 0 1 -39.6 10.53z" />
        <circle
            cx="141"
            cy="167"
            r="50"
        />
        <path d="m156 88.43v-43.43a15 15 0 0 1 30 0v11a15 15 0 0 0 30 0v-11a45 45 0 0 0 -90 0v43.43a79.39 79.39 0 0 1 30 0z" />
        <path d="m410.6 236.47a79.73 79.73 0 0 1 -79.2 0c-23.92 62.53-55.4 150.41-55.4 180.53a95 95 0 0 0 190 0c0-30.12-31.48-118-55.4-180.53z" />
        <circle
            cx="371"
            cy="167"
            r="50"
        />
        <path d="m386 88.43v-43.43a15 15 0 0 1 30 0v11a15 15 0 0 0 30 0v-11a45 45 0 0 0 -90 0v43.43a79.39 79.39 0 0 1 30 0z" />
    </svg>
</template>
